@if (model()) {
  <section id="footer">
    <div class="container">
      <div class="row">
        @if (model()?.descriptionTitle && model()?.descriptionText) {
          <div class="col-lg-3 mb-3">
            <div id="c332" class="frame frame-default frame-type-text frame-layout-0">
              <header>
                <h2
                  [innerHtml]="
                    model()?.descriptionTitle?.useTranslation
                      ? ($any(model()?.descriptionTitle?.text) | translate)
                      : model()?.descriptionTitle?.text
                  "></h2>
              </header>
              <p
                [innerHtml]="
                  model()?.descriptionText?.useTranslation
                    ? ($any(model()?.descriptionText?.text) | translate)
                    : model()?.descriptionText?.text
                "></p>
            </div>
          </div>
        }

        @if (model()?.quickLinksTitle && model()?.quickLinks) {
          <div class="col-lg-2 col-md-4 offset-lg-1 mb-3">
            <div id="c333" class="frame frame-default frame-type-text frame-layout-0">
              <header>
                <h2
                  [innerHtml]="
                    model()?.quickLinksTitle?.useTranslation
                      ? ($any(model()?.quickLinksTitle?.text) | translate)
                      : model()?.quickLinksTitle?.text
                  "></h2>
              </header>
              <ul>
                @for (link of model()?.quickLinks; track link.linkUrl) {
                  <li>
                    <a [href]="link.linkUrl" anchorExternalUrl>{{
                      link.useTranslation ? (link.text | translate) : link.text
                    }}</a>
                  </li>
                }
              </ul>
            </div>
          </div>
        }

        @if (model()?.serviceLinksTitle && model()?.serviceLinks) {
          <div class="col-lg-3 col-md-4 offset-lg-1 mb-3">
            <div id="c334" class="frame frame-default frame-type-text frame-layout-0">
              <header>
                <h2
                  [innerHtml]="
                    model()?.serviceLinksTitle?.useTranslation
                      ? ($any(model()?.serviceLinksTitle?.text) | translate)
                      : model()?.serviceLinksTitle?.text
                  "></h2>
              </header>
              <ul>
                @for (link of model()?.serviceLinks; track link.linkUrl) {
                  <li>
                    <a [href]="link.linkUrl" anchorExternalUrl>{{
                      link.useTranslation ? (link.text | translate) : link.text
                    }}</a>
                  </li>
                }
              </ul>
            </div>
          </div>
        }

        @if (model()?.contactLinksTitle && model()?.contactLinks) {
          <div class="col-lg-2 col-md-4 mb-3">
            <div id="c335" class="frame frame-default frame-type-text frame-layout-0">
              <header>
                <h2
                  [innerHtml]="
                    model()?.contactLinksTitle?.useTranslation
                      ? ($any(model()?.contactLinksTitle?.text) | translate)
                      : model()?.contactLinksTitle?.text
                  "></h2>
              </header>
              <ul>
                @for (link of model()?.contactLinks; track link.linkUrl) {
                  <li>
                    <a [href]="link.linkUrl" anchorExternalUrl>{{
                      link.useTranslation ? (link.text | translate) : link.text
                    }}</a>
                  </li>
                }
              </ul>
            </div>
            <div
              class="social-footer d-inline-flex justify-content-center flex-wrap align-items-md-start row-gap-1 column-gap-1">
              @for (s of providedSocialsUrls(); track $index) {
                <a [href]="s.url" target="_blank"><i [class]="s.icon"></i></a>&nbsp;
              }
            </div>
          </div>
        }
      </div>

      @if (model()?.gastOfferText) {
        <div class="d-flex justify-content-between align-items-center flex-wrap gap-1">
          <div class="footer-credits">
            <div id="c518" class="frame frame-default frame-type-textpic frame-layout-0">
              <div class="ce-textpic ce-left ce-below">
                <div class="ce-bodytext">
                  <p class="mb-0">
                    {{
                      model()?.gastOfferText?.useTranslation
                        ? ($any(model()?.gastOfferText?.text) | translate)
                        : model()?.gastOfferText?.text
                    }}
                  </p>
                </div>
                <div class="ce-gallery" data-ce-columns="1" data-ce-images="1">
                  <div class="ce-row">
                    <div class="ce-column">
                      <figure>
                        <img
                          class="image-embed-item img-fluid"
                          src="portal-assets/img/gast-langversion.svg"
                          [alt]="'GAST-PORTAL-NG.FOOTER-COMPONENT.GAST_IMAGE_LONG_VERSION' | translate"
                          width="400"
                          height="40" />
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            @if (model()?.showALTELogo) {
              <figure>
                <img src="portal-assets/img/alte-q-white.svg" alt="ALTEQ Q217" width="95" class="img-fluid" />
              </figure>
            } @else {
              <span class="float-end">{{ copyrightText }}</span>
            }
          </div>
        </div>
        @if (model()?.showALTELogo) {
          <div class="row">
            <div class="col-12">
              <div class="mt-3">{{ copyrightText }}</div>
            </div>
          </div>
        }
      }
    </div>
  </section>
}
